import cn from 'classnames';
import pipIcon from 'icons/picture_in_picture.svg';
import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import { TranslateMapContext } from '../../../contexts/TranslateMapContext';
import Icon from '../../Icon';
import styles from './PipStub.module.scss';

export const PIP_STUB_CONTAINER_ID = 'mggpPipStubContainer';

export const PipStub: React.FC<{ isSmallMode?: boolean }> = React.memo(
  ({ isSmallMode }) => {
    const { getTranslate } = useContext(TranslateMapContext);

    const jsx = (
      <div
        className={cn(styles.PipStub, {
          [styles.PipStub_SmallMode]: isSmallMode,
        })}
      >
        <Icon className={styles.PipStub__Icon} name={pipIcon} />
        <div className={styles.PipStub__Text}>
          {getTranslate.pipPlayerPlaceholder()}
        </div>
      </div>
    );

    const container = document.querySelector(`#${PIP_STUB_CONTAINER_ID}`);

    return container ? ReactDOM.createPortal(jsx, container) : jsx;
  }
);
PipStub.displayName = 'PipStub';
